/**
 * AppCodeEditorMonaco bond setup
 *
 * Wires @molecule/app-code-editor-monaco to @molecule/app-code-editor
 */

import { setProvider } from '@molecule/app-code-editor'
import { provider } from '@molecule/app-code-editor-monaco'

export function setupAppCodeEditorMonaco(): void {
  setProvider(provider)
}
